// extracted by mini-css-extract-plugin
module.exports = {"nameserversContainer":"ns-servers_nameserversContainer__14TCi","name":"ns-servers_name__BKIbc","copy":"ns-servers_copy__3sVPq","coped":"ns-servers_coped__lRkhI"};